module.exports = __webpack_public_path__ + "public/StoreIcon/dashboard.svg?c2f38953";